module.exports = new __parcel__URL__("gpmimergdaily.74e07d12.png").toString();